import React from 'react';
import PropTypes from 'prop-types';
import CapabilityCircle from './CapabilityCircle';
const Capability = ({ label, checked }) => (React.createElement("div", { className: "flex items-center justify-between mb-2" },
    React.createElement("label", { className: "my-0 form-label" }, label),
    React.createElement(CapabilityCircle, { checked: checked })));
Capability.propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
};
export default Capability;
